// ボタン右寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  children: React.ReactNode;
}

const RowRightButton: React.FC<Props> = ({ children }) => {
  return (
    <Row className="row-right-button">
      <Col xl={6} lg={6} md={6} sm={6} xs={12} />
      <Col className="text-end" xl={6} lg={6} md={6} sm={6} xs={12}>
        {children}
      </Col>
    </Row>
  );
};

export default RowRightButton;
